<template>
  <div class="text-xs-center">
    <v-dialog
      :value="value"
      @input="$emit('input')"
      width="100%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          Informações do Projeto
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container fluid pa-0>
            <v-layout wrap>
              <v-flex xs12>
                <v-layout wrap>
                  <div v-if="projeto.DataEmissao" class="mr-2 mb-1">
                    <h6 class="header subheading">Emissão</h6>
                    <v-chip color="default">
                      <v-avatar class="mr-0">
                        <v-icon small>event</v-icon>
                      </v-avatar>
                      {{ moment(projeto.DataEmissao).format('DD [de] MMM [de] YYYY') }}
                    </v-chip>
                  </div>
                  <div v-if="projeto.DataPrevisao" class="mr-2 mb-1">
                    <h6 class="header subheading">Previsão</h6>
                    <v-chip color="warning" text-color="white">
                      <v-avatar class="mr-0">
                        <v-icon small>event</v-icon>
                      </v-avatar>
                      {{ moment(projeto.DataPrevisao).format('DD [de] MMM [de] YYYY') }}
                    </v-chip>
                  </div>
                  <div v-if="projeto.DataFinalizacao" class="mr-2 mb-1">
                    <h6 class="header subheading">Finalização</h6>
                    <v-chip color="success" text-color="white">
                      <v-avatar class="mr-0">
                        <v-icon small>event</v-icon>
                      </v-avatar>
                      {{ moment(projeto.DataFinalizacao).format('DD [de] MMM [de] YYYY') }}
                    </v-chip>
                  </div>
                  <div v-if="projeto.Situacao" class="mr-2 mb-1">
                    <h6 class="header subheading">Situação</h6>
                    <v-chip :color="projeto.Cor" text-color="white">
                      <v-avatar class="mr-0">
                        <v-icon small>description</v-icon>
                      </v-avatar>
                      {{ projeto.Situacao }}
                    </v-chip>
                  </div>
                  <div v-if="projeto.TipoProjeto" class="mr-2 mb-1">
                    <h6 class="header subheading">Tipo</h6>
                    <v-chip color="default">
                      {{ projeto.TipoProjeto }}
                    </v-chip>
                  </div>
                  <div v-if="projeto.Responsavel" class="mr-2">
                    <h6 class="subheading">Responsável</h6>
                    <v-chip>
                      <v-avatar class="primary white--text">{{ projeto.Responsavel[0] }}</v-avatar>
                      {{ projeto.Responsavel }}
                    </v-chip>
                  </div>
                  <div v-if="projeto.IdCliente" class="mr-2">
                    <h6 class="header subheading">Cliente</h6>
                    <v-chip>
                      <v-avatar class="primary white--text">{{ projeto.Fantasia[0] }}</v-avatar>
                      {{ projeto.Fantasia }}
                    </v-chip>
                  </div>
                  <div v-if="projeto.Status" class="mr-2 mb-1">
                    <h6 class="header subheading">Status</h6>
                    <v-avatar class="mt-1" size="32" :color="statusProjeto(projeto.Status)">
                      <span class="white--text">{{ projeto.Status[0] }}</span>
                    </v-avatar>
                  </div>
                  <div v-if="projeto.ValorGut" class="mr-2">
                    <h6 class="header subheading">GUT</h6>
                    <v-progress-circular
                      :size="36"
                      :value="projeto.ValorGut || 0"
                      :color="matrizGutColor(projeto.ValorGut || 0)"
                    >
                      <span class="font-weight-medium">{{ projeto.ValorGut || 0 }}</span>
                    </v-progress-circular>
                  </div>
                  <div v-if="projeto.ValorNps !== null && projeto.ValorNps !== undefined" class="mr-2">
                    <h6 class="header subheading">NPS</h6>
                    <v-progress-circular
                      :size="36"
                      :value="npsValue(projeto.ValorNps)"
                      :color="npsColor(projeto.ValorNps)"
                    >
                      <span class="font-weight-medium">{{ projeto.ValorNps }}</span>
                    </v-progress-circular>
                  </div>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 pt-3 class="text-xs-center">
                <div class="title title-projeto">{{ projeto.Projeto }}</div>
              </v-flex>
            </v-layout>
            <!-- Grupos e Atividades -->
            <v-layout wrap>
              <v-flex xs12 pt-3>
                <span class="subheading font-weight-bold">Grupos e Atividades</span>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 v-if="itensProjetoOrdenado.length">
                <v-flex
                  xs12
                  v-for="(itemProjeto, index) in itensProjetoOrdenado"
                  :key="index"
                >
                  <v-layout py-1 row wrap align-center>
                    <v-flex md4 :class="itemProjeto.IdTipo == 1 ? 'xs8' : 'xs12'">
                      <span
                        :class="itemProjeto.IdTipo == 1 ? 'font-weight-bold' : ''"
                      >{{ itemProjeto.Classificacao }} - {{ itemProjeto.Item }}</span>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex
                      xs4
                      md1
                      v-if="itemProjeto.IdTipo == 2"
                    >
                      <div class="duracao-item">
                        <div>
                          <v-icon class="mr-1" v-if="itemProjeto.DuracaoPrevista">access_time</v-icon>
                        </div>
                        <div v-if="itemProjeto.DuracaoPrevista">
                          {{ moment(itemProjeto.DuracaoPrevista).format('HH:mm') }} <br>
                          <span
                            v-if="itemProjeto.Atividade"
                            :class="corDuracaoItemProjeto(itemProjeto.DuracaoPrevista, itemProjeto.Atividade.Duracao)"
                          >{{ moment(itemProjeto.Atividade.Duracao).format('HH:mm') }}</span>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs4 md2>
                      <v-icon class="mr-1">date_range</v-icon>
                      <span :class="itemProjeto.IdTipo == 1 ? 'font-weight-bold' : ''">
                        {{ moment(itemProjeto.PrevisaoInicial).format('DD [-]') }}
                        {{ moment(itemProjeto.PrevisaoFinal).format('DD MMM YYYY') }}
                      </span>
                    </v-flex>
                    <v-flex
                      xs4
                      md2
                      v-if="itemProjeto.IdTipo == 2 && itemProjeto.Atividade"
                    >
                      <v-icon class="mr-1">person</v-icon>
                      <span>{{ itemProjeto.Atividade.Responsavel }}</span>
                      <br v-if="$vuetify.breakpoint.smAndDown">
                      <span
                        class="pl-1 font-italic"
                      >({{ moment.utc(itemProjeto.Atividade.DataPrevisao).format('DD MMM YY') }})</span>
                    </v-flex>
                    <v-flex xs12 md2 v-if="itemProjeto.IdTipo == 2 && itemProjeto.Atividade" :class="$vuetify.breakpoint.smAndDown ? 'text-xs-center' : ''">
                      <v-chip
                        :color="itemProjeto.Atividade.Cor"
                        dark
                        :small="$vuetify.breakpoint.smAndDown"
                        v-if="itemProjeto.IdTipo == 2"
                      >{{ itemProjeto.Atividade.Situacao }}</v-chip>
                    </v-flex>
                  </v-layout>
                  <v-divider :color="itemProjeto.IdTipo == 1 ? 'gray' : ''"></v-divider>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Projeto from "@/domain/projeto/Projeto";
import { projetoService } from  '@/domain/projeto/ProjetoService';
import { matrizGutHelper } from  '@/utils/matrizGutHelper';
import { npsHelper } from '@/utils/npsHelper';

export default {
  name: "ModalInfoProjeto",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    projeto: {
      type: Object,
      default: () => new Projeto()
    },
  },
  data: () => ({
    itensProjeto: []
  }),
  watch: {
    value(value) {
      if (value) this.inicializaBuscas();
    }
  },
  computed: {
    itensProjetoOrdenado() {
      return this.itensProjeto.sort(
        (a, b) => a.Classificacao - b.Classificacao
      );
    }
  },
  methods: {
    inicializaBuscas() {
      projetoService.getItensProjeto(this.projeto.IdProjeto)
        .then(response => this.itensProjeto = response.data)
        .catch(error => console.log(error));
    },
    npsValue(valor) {
      return npsHelper.npsValue(valor);
    },
    npsColor(valor) {
      return npsHelper.npsColor(valor);
    },
    matrizGutColor(valor) {
      return matrizGutHelper.matrizGutColor(valor);
    },
    statusProjeto(status) {
      status = status.trim();
      if (status == "A") return "#263238";
      if (status == "F") return "#1976d2";
      if (status == "C") return "#bdbdbd";
    },
    corDuracaoItemProjeto(prevista, realizada) {
      if (this.moment(prevista).isSame(realizada)) return "";
      if (this.moment(prevista).isBefore(realizada)) return "error--text";
      if (this.moment(prevista).isAfter(realizada)) return "success--text";
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1.125rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
.duracao-item {
  display: flex;
  align-items: center;
}
.title-projeto {
  padding: 10px 0;
  border-top: 2px solid rgba(0, 0, 0, .9);
  border-bottom: 2px solid rgba(0, 0, 0, .9);
}
</style>